import { all, put, call, takeEvery, select } from 'redux-saga/effects';

import * as Sentry from '@sentry/react';

import { SET_SERVER_ERROR, SUBMIT_CUSTOM_REPORT } from '../../actions/general';
import { ERROR, ERROR_TAKE_EVERY, SAVE_ERROR } from '../../../consts/errors';
import { VOX_SHOW_ERROR } from '../../../consts/vox';

import { serializeError, serializeServerError } from '../../serializers/error';

import { SEND_MESSAGE_FAILURE } from '../../actions/chains';

import { LISTEN_CALL_FAILURE } from '../../actions/calls';

export function* safeCall(effect, ...args) {
  try {
    return yield call(effect, ...args);
  } catch (error) {
    console.error(error);
    yield put({
      error: {
        error: JSON.stringify(error),
        funcName: effect.name,
        message: error.message,
      },
      type: ERROR,
    });
    return null;
  }
}

export function safeApply(effect, ...initialArgs) {
  const wrapped = function* wrappedTryCatch(...args) {
    try {
      yield call(effect, ...initialArgs, ...args);
    } catch (error) {
      console.error(error);
      yield put({
        error: {
          error,
          funcName: effect.name,
          message: error.message,
        },
        type: ERROR_TAKE_EVERY,
      });
    }
  };

  return wrapped;
}

function* handleServerError({ error }) {
  if (!error && !error.url) return;

  yield put({
    error: serializeServerError(error),
    type: SAVE_ERROR,
  });

  Sentry.captureException(JSON.stringify(error));
}

function* handleError({ error }) {
  if (!error && !error.funcName) return;

  switch (error.funcName) {
    case 'build':
    case 'setVoxStatus':
    case 'fetchData':
      break;

    default:
      yield put({
        error: serializeError(error),
        type: SAVE_ERROR,
      });
      break;
  }
}

function* handleCustomError({ error }) {
  if (!error) return;

  yield put({
    error: {
      title: error,
      message: '',
      createdAt: Math.round(new Date().getTime() / 1000),
    },
    type: SAVE_ERROR,
  });
}

function* alertError({ error, message }) {
  // yield safeCall(alert, error || VOX_ERRORS.UKNOWN);
  yield console.log('VOX ERROR', error, message);
}

function* sendCustomReport({ text, category }) {
  const stateForSending = yield select(state => state[category]);
  const generalState = { ...(yield select(({ general }) => general)) };

  // фильтруем ненужные поля в объектах стейта
  if (category === 'tickets') {
    delete stateForSending.options;
  }
  delete generalState.token;

  Sentry.withScope(scope => {
    scope.setExtra('eventType', 'message');
    scope.setExtra('choosenState', JSON.stringify(stateForSending));
    scope.setExtra('generalState', JSON.stringify(generalState));

    Sentry.captureException(text);
  });
}

export default function* () {
  yield all([
    yield takeEvery([ERROR, ERROR_TAKE_EVERY], handleError),
    yield takeEvery(
      [LISTEN_CALL_FAILURE, SEND_MESSAGE_FAILURE],
      handleCustomError
    ),
    yield takeEvery(SET_SERVER_ERROR, handleServerError),
    yield takeEvery(VOX_SHOW_ERROR, alertError),
    yield takeEvery(SUBMIT_CUSTOM_REPORT, sendCustomReport),
  ]);
}
